import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import BarChart from '../../components/Charts/BarChart';
import LineChart from '../../components/Charts/LineChart';
import DashboardOne from './DashboardOne';
import DashboardTwo from './DashboardTwo';
import UserDashboard from './UserDashboard';
const Dashboard = () => {
  const { userDetails, activeDashboard } = useSelector((state) => state.user);

  useEffect(() => {
    document.title = 'ISE – Prepaid Electricity Management Portal';
  }, []);

  return (
    <div>
      {userDetails.role === 'user' ? (
        <UserDashboard />
      ) : activeDashboard ? (
        <DashboardOne id={activeDashboard} />
      ) : (
        // <DashboardTwo />
        <div className="mt-4 text-center">
          {activeDashboard === null ? <h1>Loading dashboard...</h1> : <h1>No dashboard selected</h1>}
        </div>
      )}

      {/* <div className="az-content-body">
        <div className="row mb-3">
          <div className='col-md-4'>
            <select className="form-select">
              <option value="kuchai">Current View - Power Usage</option>
              <option value="kuchai">Power Usage 2</option>
            </select>
          </div>
          <div className="col-md-2">
            <select className="form-select">
              <option value="kuchai">Today</option>
              <option value="kuchai">This Week</option>
              <option value="kuchai">This Month</option>
              <option value="kuchai">This Year</option>
            </select>
          </div>
          <div className="col-md-2">
            <select className="form-select">
              <option value="kuchai">Select Sensor</option>
              <option value="kuchai">Sensor 1</option>
              <option value="kuchai">Sensor 2</option>
              <option value="kuchai">Sensor 3</option>
            </select>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-2">
            <div className="card p-3 text-center mb-2">
              <h6 className="card-title">This Month Total Usage</h6>
              <p className='text-danger fs-4 fw-bold'>37.5 MWh</p>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card p-3 text-center mb-2">
              <h6 className="card-title">Today Total Usage</h6>
              <h2 className='text-danger fs-3'>161 kWh</h2>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card p-3 text-center mb-2">
              <h6 className="card-title">This Month Total Cost(RM)</h6>
              <h2 className='text-danger fs-3'>18.389.33</h2>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card p-3 text-center mb-2">
              <h6 className="card-title">Today Total Cost(RM)</h6>
              <h2 className='text-danger fs-3'>69.85</h2>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card p-3 text-center mb-2">
              <h6 className="card-title">This Month Total CO2</h6>
              <h2 className='text-danger fs-3'>25,914</h2>
            </div>
          </div>
          <div className="col-md-2">
            <div className="card p-3 text-center mb-2">
              <h6 className="card-title">Total CO2 For Today</h6>
              <h2 className='text-danger fs-3'>111</h2>
            </div>
          </div>
        </div>

        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-lg-12">
            <div className="card card-dashboard-six">
              <div className="card-header">
                <div>
                  <label className="az-content-label">Source Overview</label>
                  <span className="d-block">Power Usage in 2022</span>
                </div>
              </div>
              <LineChart />
            </div>
          </div>
        </div>
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-lg-12">
            <div className="card card-dashboard-six">
              <div className="card-header">
                <div>
                  <label className="az-content-label">Usage Overview</label>
                  <span className="d-block">Power Usage in 2022</span>
                </div>
              </div>
              <BarChart />
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;
